import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { generateOneLinkUrl } from '@cian/appsflyer-onelink';
import * as React from 'react';

import { MOBILE_APP_BANNER_TITLE } from './constants';
import { trackMobileAppBannerClick, trackMobileAppBannerShow } from './tracking';
import { MobileAppBanner } from '../../components/MobileAppBanner';
import { useDownLoadAppUrl } from '../../utils/useShowMobileAppBanner';

export const MobileAppBannerContainer = () => {
  const downLoadUrl = useDownLoadAppUrl();

  const [mobileBannerDownloadUrl, setMobileBannerDownloadUrl] = React.useState<string | null>(downLoadUrl || '');

  React.useEffect(() => {
    setMobileBannerDownloadUrl(generateOneLinkUrl(mobileBannerDownloadUrl, 'mobile_site', MOBILE_APP_BANNER_TITLE));
  }, []);

  return (
    <ActionAfterViewObserver callback={trackMobileAppBannerShow} percentVisible={0.8} triggerOnce>
      <MobileAppBanner url={mobileBannerDownloadUrl || ''} onClick={trackMobileAppBannerClick} />
    </ActionAfterViewObserver>
  );
};

MobileAppBannerContainer.displayName = 'MobileAppBannerContainer';
